import axios from 'axios'
import React, { useContext, useRef, useState } from 'react'
import Button from '../../../button/Button'
import Input from '../../../input/Input'
import { IState } from 'src/Interface'
import { StateContext } from '../../../../AppContext'
import styles from './add-company.module.scss'
import { baseApiURL } from 'src/utils/utils'
import AutocompletePoi from '../../../autocomplete/AutocompletePoi'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { validEmail, validString } from 'src/utils/utils'
import { DispatchContext } from 'src/AppContext'
import ImagePlaceHolder from 'src/assets/images/copy.svg'

interface Props {
  close: () => void
  hideArchieved: boolean
}

const AddCompany: React.FunctionComponent<Props> = ({ close, hideArchieved }: Props) => {
  const state: IState = useContext(StateContext)
  const dispatch = useContext(DispatchContext)
  const imageRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [values, setValues] = useState({
    name: null,
    contactPerson: null,
    email: null,
    address: null
  })

  const [validationErrors, setValidationErrors] = useState({
    name: false,
    contactPerson: false,
    email: false
  })

  const [errors, setErrors] = useState({
    name: false
  })

  const [file, setFile] = useState<any>(null)

  const handleInputChange = (fieldName: string) => (value: string) => {
    setValues({
      ...values,
      [fieldName]: value
    })
  }

  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })

    setValidationErrors({
      ...validationErrors,
      [fieldName]: false
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true
    }
    setValidationErrors({
      ...validationErrors,
      [fieldName]: error
    })
  }


  const toBase64 = (file: File) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

  const filese = async (file: File) => {
    const base64: any = await toBase64(file)
    imageRef.current.src = base64
    setFile(base64.replace(`data:${file.type};base64,`, ''))
  }

  const addNewCompany = () => {
    const body = {
      image: file ? {
        imageData: file,
        contentType: 'string'
      } : null,
      name: values.name,
      address: values.address,
      contactPerson: values.contactPerson,
      email: values.email
    }
    setIsLoading(true)
    axios.post(`${baseApiURL()}/companies`, {
      ...body
    }, {
      headers: {
        Authorization: `Bearer ${state.user.accessToken}`
      }
    }).then((result) => {
      return result.data.companyId
    }).then((companyId) => {
      return axios(`${baseApiURL()}/companies/${companyId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
    }).then((result) => {
      setIsLoading(false)
      toast('Medarbejder oprettet')
      close()
      dispatch({ type: 'SET_COMPANIES', companies: [result.data, ...state.companies] })
    }).catch(error => {
      setIsLoading(false)
      if (error.response.data.message.startsWith('Key (name)=(')) {
        setErrors({
          ...error,
          name: true
        })
      } else {
        if (error.response) {
          toast(error.response.data.message)
        } else {
          toast('Der gik desværre noget galt. Prøv igen om lidt')
        }
      }
    });
  }

  return (
    <div className={styles.addCompany}>
      <header className={styles.header}>
        <h4>Opret kunde</h4>
      </header>
      <div className={styles.container}>
        <div className='tw-flex tw-mb-3'>
          <div className={styles.logoContainer}>
            <img className={`${styles.logo} ${!file ? styles.placeholderLogo : ''}`} src={ImagePlaceHolder} ref={imageRef} alt="" />
          </div>
          <input accept='.png,.jpg,.jpeg' className={styles.file} onChange={(e) => filese(e.target.files[0])} type="file" name="" id="" />
        </div>
        <div className='tw-mb-3'>
          <Input
            label='Firmanavn *'
            type='text'
            value={values.name}
            error={validationErrors.name || errors.name}
            resetError={() => resetError('name')}
            handleValidation={() => handleValidation(validString, 'name')}
            handleInputChange={() => handleInputChange('name')}
            name='name'
            placeholder='Indtast firmanavn'
          />
          {errors.name && <p className='errorMsg'>Virksomhedsnavnet eksisterer allerede. </p>}
          {validationErrors.name && <p className='errorMsg'>Virksomhedsnavnet bør være mellem 2 og 32 karakterer.</p>}
        </div>
        <AutocompletePoi
          modifiers='tw-mb-3'
          label='Addresse *'
          setAddress={() => handleInputChange('address')}
          name='addresse'
          placeholder='Indtast firmaadresse'
        />
        <div className='tw-mb-3'>
          <Input
            label='Kontakt person *'
            type='text'
            value={values.contactPerson}
            error={validationErrors.contactPerson}
            resetError={() => resetError('contactPerson')}
            handleValidation={() => handleValidation(validString, 'contactPerson')}
            handleInputChange={() => handleInputChange('contactPerson')}
            name='contactPerson'
            placeholder='Indtast kontaktperson'
          />
          {validationErrors.contactPerson && <p className='errorMsg'>Navnet bør være mellem 2 og 32 karakterer.</p>}

        </div>
        <div className='tw-mb-3'>
          <Input
            label='Email *'
            type='text'
            value={values.email}
            error={validationErrors.email}
            resetError={() => resetError('email')}
            handleValidation={() => handleValidation(validEmail, 'email')}
            handleInputChange={() => handleInputChange('email')}
            name='email'
            placeholder='Indtast email til kontaktperson'
          />
          {validationErrors.email && <p className='errorMsg'>Emailen ser ikke ud til at være i et korrekt format.</p>}
        </div>
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' handleClick={close} />
        <Button loading={isLoading} type='primary' label='Opret kunde' disabled={!(values.name && values.address && values.contactPerson && values.email)} handleClick={addNewCompany} />
      </footer>
    </div>
  )
}

export default AddCompany
